import React, { Component } from 'react';
import { DragSource } from 'react-dnd';
import Svg from 'Components/Svg';

const dragItemSource = {
    beginDrag(props) {
        return {
            type: 'card',
            from: 'left',
            datatype: props.items.value,
            notMetaData: true
        };
    },

};

const DragItem = ({ items, connectDragSource, onDragItemClick }) => {
    const { datatype, name, icon, nowrap } = items;
    return connectDragSource(
        <div className="drag-item-wrapper" key={datatype} onClick={onDragItemClick}>
            <div className="drag-item" title={name}>
                <Svg xlinkHref={`#icon-${icon}`}/>
                <span className="name">{name}</span>
            </div>
        </div>
    )
}

export default DragSource('card', dragItemSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
}))(DragItem)
